module.exports = __webpack_public_path__ + "img/1547380568.c6927e16.jpg";